// Helpers d'auth côté frontend.
//
// Contexte : NPM gate /admin* et /api/admin/* via Authentik forward-auth
// (cf. DEPLOYMENT.md). Quand la session a expiré, NPM répond 302 vers
// auth.skilltech.tools/outpost.goauthentik.io/start?rd=... — cross-origin.
// Un fetch() suit le redirect par défaut, tombe sur le HTML de login Authentik
// qui n'a pas de header Access-Control-Allow-Origin pour notre domaine →
// erreur CORS dans la console et fetch qui throw / renvoie une opaque response.
//
// Pour éviter ça : dès qu'un fetch admin reflète une session expirée
// (res.redirected = true, ou throw CORS), on bascule en vraie navigation
// vers Authentik. L'utilisateur se relog, revient sur la page d'origine,
// et les prochains fetches partent avec une session valide.
//
// Les endpoints publics sous /api/admin/ (questions/:id, schedules/:userId,
// cf. snippet NPM) NE doivent PAS passer par adminFetch — ils ne sont pas
// gatés, ils répondent normalement.
//
// En dev local (npm run dev) il n'y a pas de NPM ni d'Authentik en front,
// donc `/outpost.goauthentik.io/...` n'existe pas et renverrait du 404.
// On bascule vers une navigation directe sur la cible : le serveur Express
// utilise alors son fallback cookie (getUser() dans server/index.js) pour
// créer un user anonyme et tout marche end-to-end sans SSO.

const AUTH_START = '/outpost.goauthentik.io/start?rd=';

// Vraie navigation (pas une fetch) vers le flow login Authentik. Par défaut
// on revient sur l'URL courante après login ; on peut forcer une autre cible
// via rd (utile depuis la WelcomeScreen pour pointer vers /admin).
// En dev : nav directe sur la cible (pas d'Authentik installé en front).
export function redirectToAuth(rd: string = window.location.pathname + window.location.search): void {
  if (import.meta.env.DEV) {
    window.location.href = rd;
    return;
  }
  window.location.href = `${AUTH_START}${encodeURIComponent(rd)}`;
}

// Wrapper fetch pour endpoints admin gatés. Si la session a expiré → vraie
// navigation vers Authentik et retour null (le caller doit early-return).
// Sinon → Response standard, le caller la traite comme d'habitude.
export async function adminFetch(input: RequestInfo, init?: RequestInit): Promise<Response | null> {
  try {
    const res = await fetch(input, init);
    if (res.redirected) {
      redirectToAuth();
      return null;
    }
    return res;
  } catch {
    // CORS bloqué (cross-origin redirect vers Authentik) ou réseau down :
    // dans les deux cas, on tente la relog.
    redirectToAuth();
    return null;
  }
}
